<template>
  <div style="height: 100%; min-height: 100vh">
    <v-container v-show="loading" style="height: 100%">
      <v-layout row justify-center align-center style="height: 100%">
        <v-flex class="text-xs-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout
      v-show="noRoom && !isError && !loading"
      class="text-xs-center"
      fill-height
      column
      justify-center
    >
      <div>
        <h3 class="headline">Room not found</h3>
        <v-btn color="primary">Back</v-btn>
      </div>
    </v-layout>
    <v-layout
      v-show="isError && !noRoom && !loading"
      class="text-xs-center"
      fill-height
      column
      justify-center
    >
      <div>
        <h3 class="headline">{{ errorlist }}</h3>
        <v-btn color="primary">Back</v-btn>
      </div>
    </v-layout>

    <div v-show="!loading && !noRoom && !isError">
      <v-container>
        <h3 class="text-xs-center headline primary--text mb-4">
          Booking Summary
        </h3>
        <template v-if="room">
          <v-layout row wrap justify-left>
            <v-flex
              v-for="(item, i) in room.RoomPhotos.ThumbnailUrl"
              :key="i"
              xs6
              sm2
              lg1
              class="pa-1"
              d-flex
            >
              <v-card flat tile class="d-flex">
                <v-img
                  :src="'https://ibs.instant-bookings.com/medias' + room.RoomPhotos.ThumbnailUrl[i]"
                  :lazy-src="
                    'https://ibs.instant-bookings.com/medias' + room.RoomPhotos.MiniatureUrl[i]
                  "
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                <v-layout
                  style="
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                  "
                  class="text-xs-center"
                  justify-center
                  column
                >
                  <v-btn
                    @click="
                      onPreviewImage(
                        'https://ibs.instant-bookings.com/medias' + room.RoomPhotos.Url[i]
                      )
                    "
                    fab
                    depressed
                    dark
                    small
                    color="rgba(0,0,0,.2)"
                    style="margin: auto"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>

          <v-dialog
            v-model="showPreview"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar flat color="white">
                <v-btn icon @click="showPreview = false">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Preview</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <div>
                <v-img v-if="previewUrl" :src="previewUrl" alt style="width: 100%" />
              </div>
            </v-card>
          </v-dialog>
        </template>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <template v-if="room">
          <h3 class="primary--text">{{ room.RoomName }}</h3>
          <p v-html="decodeHtml(room.RoomDetail.BedTypeDescription)"></p>
          <p v-html="decodeHtml(room.RoomDetail.DescriptionEng)"></p>
          <p v-html="decodeHtml(room.RoomDetail.OtherPropertieDescription)"></p>
        </template>
      </v-container>
      <v-divider></v-divider>
      <v-container>
        <template v-if="room">
          <template v-if="room.LeisureAmenities && room.LeisureAmenities.split(',').length > 0">
            <h3 class="primary--text">Facilities & Services</h3>
            <u class="mt-2">Leisure Facilities</u>
            <ul class="mb-2">
              <template v-for="key in room.LeisureAmenities.split(',')">
                <li
                  v-if="room.RoomDetail.Amenities[key]"
                  :key="key"
                  v-html="room.RoomDetail.Amenities[key].AmenitiesName"
                ></li>
              </template>
            </ul>
          </template>

          <template
            v-if="room.DiningDrinkAmenities && room.DiningDrinkAmenities.split(',').length > 0"
          >
            <u class="mt-2">Dining & Drink</u>
            <ul class="mb-2">
              <template v-for="key in room.DiningDrinkAmenities.split(',')">
                <li
                  v-if="room.RoomDetail.Amenities[key]"
                  :key="key"
                  v-html="room.RoomDetail.Amenities[key].AmenitiesName"
                ></li>
              </template>
            </ul>
          </template>

          <template v-if="room.OtherAmenities && room.OtherAmenities.split(',').length > 0">
            <u class="mt-2">Other Facilities</u>
            <ul class="mb-2"></ul>
              <template v-for="key in room.OtherAmenities.split(',')">
                <li
                  v-if="room.RoomDetail.Amenities[key]"
                  :key="key"
                  v-html="room.RoomDetail.Amenities[key].AmenitiesName"
                ></li>
              </template>
            </ul>
          </template>

          <template
            v-if="room.AccessibilityAmenities && room.AccessibilityAmenities.split(',').length > 0"
          >
            <u class="mt-2">Accessibility Facilities</u>
            <ul class="mb-2">
              <template v-for="key in room.AccessibilityAmenities.split(',')">
                <li v-if="room.RoomDetail.Amenities[key]" :key="key" v-html="room.RoomDetail.Amenities[key].AmenitiesName">

                </li>
              </template>
            </ul>
          </template>
        </template>
      </v-container>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import numeral from "numeral";
import moment from "moment";
import CryptoJS from "crypto-js";
import queryString from "query-string";

export default {
  data() {
    return {
      hotel: null,
      review: null,
      room: null,
      loading: true,
      noRoom: true,
      showCancelPolicy: false,
      showPrivacyPolicy: false,
      apikey: "verandachatbot",
      secret: "5f@f=3pW6*BTnq*R",
      firstname: "",
      lastname: "",
      title: "Mr.",
      nationality: "Thailand",
      email: "",
      roomdetail: {
        guestname: "",
        guestnameInputName: "",
        email: "",
        emailInputName: "",
        hiddenAdultInputName: "",
        hiddenChildInputName: "",
        hiddenInfantInputName: "",
      },
      telCode: "Thailand (+66)",
      tel: "",

      isEditRoom1: false,
      paymentMethod: "KBANK",
      paymentMethodOptions: {},
      paymentDetail: {
        creditCardNumber: "",
        expireMonth: "",
        expireYear: "",
        cardHolderName: "",
        bankHolderName: "",
      },
      expireMonthOptions: [],
      expireYearOptions: [],
      titleOptions: [],
      telCountryCodeOptions: [],
      countryCodeOptions: [],
      isError: false,
      errorlist: null,
      previewUrl: null,
      showPreview: false,
    };
  },
  mounted() {
    this.queryinit();
    this.init();
    var vm = this;
    vm.loading = true;

    vm.ipLookUp().then(
      (response) => {
        if (response && response.country) {
          vm.nationality = response.country;
          var telCode = vm.telCountryCodeOptions.find((country) => {
            return country.value.includes(response.country);
          });
          if (telCode) {
            vm.telCode = telCode.value;
          }
        }
      },
      (err) => {}
    );
    vm.getRoomrateavailiable().then(
      (response) => {
        if (response.StatusCode == 200 && response.Data) {
          var data = response.Data.Response;
          var vm = this;
          var hotelRoomID = vm.$route.query.HotelRoomID ? vm.$route.query.HotelRoomID : null;

          var room = data.Hotel.Rooms.find((room) => {
            return room.HotelRoomID == hotelRoomID;
          });

          if (!room) {
            this.noRoom = true;
          } else {
            vm.room = room;
          }
          this.loading = false;
          this.noRoom = false;
        }
      },
      (error) => {
        vm.loading = false;
        vm.isError = true;
        vm.errorlist = error;
      }
    );
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    view() {
      return this.$store.state.query.view;
    },
  },
  methods: {
    queryinit() {
      var vm = this;
      vm.$store.state.query = vm.$route.query["liff.state"]
        ? queryString.parse(vm.$route.query["liff.state"])
        : vm.$route.query;
    },
    init() {
      var vm = this;
      var liffid = vm.$liffid.room;
      if (this.query.apptype == "line") {
        this.initializeLiff(liffid);
      } else {
        window.extAsyncInit = function() {
          // the Messenger Extensions JS SDK is done loading
          // vm.loading = false;
        };
      }
    },
    async initializeLiff(myLiffId) {
      var vm = this;
      var redirectUri = window.location.href;
      try {
        await this.$liff.init({
          liffId: myLiffId,
        });
        if (await this.$liff.isLoggedIn()) {
          // alert("loggedin");
          this.$store.state.profile = await this.$liff.getProfile();
          // vm.loading = false;
        } else {
          await this.$liff.login({ redirectUri });
        }
      } catch (error) {
        // alert(error.message);
      }
    },
    onPreviewImage(url) {
      this.previewUrl = url;
      this.showPreview = true;
    },
    onCopyAbove() {
      this.roomdetail.guestname = this.title + " " + this.firstname + " " + this.lastname;
      this.roomdetail.email = this.email;
      this.isEditRoom1 = false;
    },
    decimalFormat(value) {
      return numeral(value).format("00.0000");
    },
    goToErrorInput: function() {
      var vm = this;
      $.each(vm.$validator.errors.items, function(index, error) {
        if (vm.$el.querySelector('[data-vv-name="' + error.field + '"]')) {
          vm.$nextTick(function() {
            vm.$el.querySelector('[data-vv-name="' + error.field + '"]').scrollIntoView();
          });
          return false;
        } else if (vm.$el.querySelector('[name="' + error.field + '"]')) {
          vm.$nextTick(function() {
            vm.$el.querySelector('[name="' + error.field + '"]').scrollIntoView();
          });
          return false;
        }
      });
    },
    decodeHtml: function(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    validateBooking(e) {
      var vm = this;
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput();
          return false;
        }

        vm.loading = true;
        vm.sendTransaction().then((response) => {
          vm.submitBooking();
        });
      });
    },
    submitBooking() {
      var vm = this;
      this.$refs.form.submit();
    },
    ipLookUp: async function() {
      try {
        let response = await $.ajax("http://ip-api.com/json");
        return response;
      } catch (error) {
        return null;
      }
    },
    getRoomReview: async function(rooms) {
      try {
        var vm = this;
        var userid = vm.$route.query.userid ? vm.$route.query.userid : null;
        var hotelid = vm.$route.query.HotelID ? vm.$route.query.HotelID : null;
        var night = vm.$route.query.Night ? vm.$route.query.Night : null;
        var adult = vm.$route.query.Adult ? vm.$route.query.Adult : null;
        var child = vm.$route.query.Child ? vm.$route.query.Child : 0;
        var arrivalDate = vm.$route.query.ArrivalDate ? vm.$route.query.ArrivalDate : null;
        var departureDate = vm.$route.query.DepartureDate ? vm.$route.query.DepartureDate : null;
        var hotelRoomID = vm.$route.query.HotelRoomID ? vm.$route.query.HotelRoomID : null;
        if (
          !hotelRoomID ||
          !userid ||
          !hotelid ||
          night == null ||
          adult == null ||
          !arrivalDate ||
          !departureDate
        ) {
          this.noRoom = true;
          this.loading = false;
          return false;
        }

        var room = rooms.find((room) => {
          return room.HotelRoomID == hotelRoomID;
        });

        if (!room) {
          this.noRoom = true;
          this.loading = false;
          return false;
        }
        this.noRoom = false;

        arrivalDate = moment(arrivalDate);
        departureDate = moment(departureDate);

        var data = {
          HotelID: hotelid,
          ArrivalDate: arrivalDate.format("DD/MM/YYYY"),
          DepartureDate: departureDate.format("DD/MM/YYYY"),
          Night: night,
          Adult: adult,
          Child: child,
          NoofRoom: 1,
          PromotionCode: "",
          Language: 'th',
          Currency: "THB",
          LandingPageList: '',
          Country: 'TH',
          Device: "pc",
          InsiderDeal: 0,
          Ratekey: 0,
          RateType: 1,
          IPAddress: "171.98.156.83",
          HotelKey: null,
          BookingKey: null,
          NumberOfRoom: 1,
          Platform: "",
          Browser: "",
          Version: "",
          Cookies: "",
          JavaScript: "",
          MobileDeviceModel: "",
          SessionID: "",
          LandingPage: "",
          BookingPaymentKey: null,
          PaymentMethod: null,
          chatbotuserid: userid,
          channel: "chatbot",
          BookingItem: [
            {
              rate_id: room.RoomRate[0].HotelRoomRateCode,
              rate_type: room.RoomRate[0].TypeID,
              item_title: room.RoomRate[0].RoomName,
              item_title_sec: room.RoomRate[0].RoomTypeName,
              allot_id: room.RoomRate[0].HotelRoomAllotmentID,
              item_details: "",
              item_cancels: room.RoomRate[0].CancellationPolicy,
              item_is_promotion: true,
              item_promotion_id: room.RoomRate[0].HotelPromotionID,
              item_promotion_title: room.RoomRate[0].PromotionHighlightName,
              item_promotion_title_sec: room.RoomRate[0].PromotionName,
              item_promotion_description: "",
              item_is_coupon: false,
              item_coupon_id: 0,
              item_coupon_title: "",
              item_coupon_title_sec: "",
              item_coupon_description: "",
              Currency: room.RoomRate[0].Currency,
              rateplan_price: room.RoomRate[0].BasePrice,
              rateplan_price_currency: room.RoomRate[0].BasePrice_currency,
              rateplan_price_display: "",
              price: room.RoomRate[0].TotalPrice,
              price_currency: room.RoomRate[0].TotalPrice_currency,
              price_currency_display: "",
              room_id: hotelRoomID,
            },
          ],
        };
        var settings = {
          async: true,
          url: "https://ibs.instant-bookings.com/Bookingservices/review",
          method: "POST",
          crossDomain: true,
          headers: {
            "Content-Type": "application/json",
            APIKEY: this.apikey,
            SignatureKey: this.getSignatureKey(),
          },
          processData: false,
          data: JSON.stringify(data),
        };

        let response = await $.ajax(settings);
        return response;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    getRoomrateavailiable: async function() {
      try {
        var vm = this;
        var userid = vm.$route.query.userid ? vm.$route.query.userid : null;
        var hotelid = vm.$route.query.HotelID ? vm.$route.query.HotelID : null;
        var night = vm.$route.query.Night ? vm.$route.query.Night : null;
        var adult = vm.$route.query.Adult ? vm.$route.query.Adult : null;
        var child = vm.$route.query.Child ? vm.$route.query.Child : 0;
        var arrivalDate = vm.$route.query.ArrivalDate ? vm.$route.query.ArrivalDate : null;
        var departureDate = vm.$route.query.DepartureDate ? vm.$route.query.DepartureDate : null;
        var hotelRoomID = vm.$route.query.HotelRoomID ? vm.$route.query.HotelRoomID : null;

        if (
          !userid ||
          !hotelid ||
          night == null ||
          adult == null ||
          !arrivalDate ||
          !departureDate
        ) {
          this.noRoom = true;
          this.loading = false;
          return false;
        }

        arrivalDate = moment(arrivalDate);
        departureDate = moment(departureDate);

        var settings = {
          async: true,
          url: "https://ibs.instant-bookings.com/Bookingservices/roomrateavailiable",
          method: "POST",
          crossDomain: true,
          headers: {
            "Content-Type": "application/json",
            APIKEY: this.apikey,
            SignatureKey: this.getSignatureKey(),
          },
          processData: false,
          data: JSON.stringify({
            HotelID: hotelid,
            ArrivalDate: arrivalDate.format("MM/DD/YYYY"),
            DepartureDate: departureDate.format("MM/DD/YYYY"),
            Night: night,
            Adult: adult,
            Child: child,
            CouponCode: "",
            Language: "th",
            Currency: "THB",
            LandingPageList: "",
            Country: "TH",
            Device: "pc",
            InsiderDeal: 0,
            Ratekey: 0,
            Ratetype: 1,
            chatbotuserid: userid,
            channel: "chatbot",
            IPAddress: "171.98.156.83",
          }),
        };

        let response = await $.ajax(settings);
        return response;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    sendTransaction: async function() {
      try {
        var vm = this;
        var userid = vm.$route.query.userid ? vm.$route.query.userid : null;
        var hotelid = vm.$route.query.HotelID ? vm.$route.query.HotelID : null;
        var night = vm.$route.query.Night ? vm.$route.query.Night : null;
        var adult = vm.$route.query.Adult ? vm.$route.query.Adult : null;
        var child = vm.$route.query.Child ? vm.$route.query.Child : 0;
        var arrivalDate = vm.$route.query.ArrivalDate ? vm.$route.query.ArrivalDate : null;
        var departureDate = vm.$route.query.DepartureDate ? vm.$route.query.DepartureDate : null;
        var hotelRoomID = vm.$route.query.HotelRoomID ? vm.$route.query.HotelRoomID : null;
        if (
          !hotelRoomID ||
          !userid ||
          !hotelid ||
          night == null ||
          adult == null ||
          !arrivalDate ||
          !departureDate
        ) {
          this.noRoom = true;
          this.loading = false;
          return false;
        }

        arrivalDate = moment(arrivalDate);
        departureDate = moment(departureDate);

        var settings = {
          async: true,
          url: "https://communitybotbyzwizai.herokuapp.com/datareserveroom",
          method: "POST",
          crossDomain: true,
          headers: {
            "Content-Type": "application/json",
          },
          processData: false,
          data: JSON.stringify({
            userid: userid,
            temporderid: this.review.BookingTemporaryID,
            reservedata: {
              hotelid: hotelid,
              adult: adult,
              child: child,
              night: night,
              roomid: hotelRoomID,
            },
            firstname: this.firstname,
            lastname: this.lastname,
            title: this.title,
            email: this.email,
            phone: this.tel,
          }),
        };

        let response = await $.ajax(settings);
        return response;
      } catch (error) {
        console.error(error);
        return null;
      }
    },
    getSignatureKey: function() {
      var utcDate = Math.floor(new Date().getTime() / 1000);
      utcDate = utcDate - 10;
      var assemble = this.apikey + this.secret + utcDate;
      var hash = CryptoJS.SHA256(assemble).toString();
      var encryption = hash.toString(CryptoJS.enc.Hex);
      return encryption;
    },
  },
  filters: {
    decimalFormat(value) {
      return numeral(value).format("0,0.00");
    },
  },
  watch: {
    title: function(newVal, oldVal) {
      if (!this.isEditRoom1 && newVal != oldVal) {
        this.roomdetail.guestname = this.title + " " + this.firstname + " " + this.lastname;
      }
    },
    firstname: function(newVal, oldVal) {
      if (!this.isEditRoom1 && newVal != oldVal) {
        this.roomdetail.guestname = this.title + " " + this.firstname + " " + this.lastname;
      }
    },
    lastname: function(newVal, oldVal) {
      if (!this.isEditRoom1 && newVal != oldVal) {
        this.roomdetail.guestname = this.title + " " + this.firstname + " " + this.lastname;
      }
    },
    email: function(newVal, oldVal) {
      if (!this.isEditRoom1 && newVal != oldVal) {
        this.roomdetail.email = this.email;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
